import { JsonLdResult } from 'src/templates/queries/types';
import { getJsonLdResultValue } from 'src/utils/jsonld/getJsonLdResultValue';

export const getJsonLdResultPreferredValue = (
  result: JsonLdResult,
  predicates: string[],
  getDefault?: (result: JsonLdResult) => string
) => {
  let value = '';
  const language = navigator.language.match(/^[a-z]*(?!:-)/)?.[0] || 'en';

  const foundValue = predicates.some((predicate) => {
    const predicateValue = result[predicate];
    if (predicateValue === undefined) {
      return false;
    }

    value =
      getJsonLdResultValue(predicateValue, (result) =>
        Boolean(
          typeof result !== 'string' &&
            result['@language'] &&
            language === result['@language']
        )
      ) ||
      getJsonLdResultValue(predicateValue, (result) =>
        Boolean(typeof result === 'string' || !result['@language'])
      );

    return true;
  });

  if (!foundValue && getDefault) {
    value = getDefault(result);
  }

  return value;
};
